/* ============================================================
   JOWI — aviso.js
   Los dos formularios de captacion de la tienda sin stock:
     · ficha    → snippets/aviso-stock.liquid   (correo + telefono + TALLA)
     · portada  → sections/home-aviso.liquid    (correo + telefono + texto libre)

   Van juntos en un solo fichero porque comparten lo unico que de verdad
   importa: como se valida, como se manda y que pasa cuando falla.

   =========================  LO QUE NO SE HACE  =========================

   1. NO HAY `mode: 'no-cors'`.
      Es lo que mas caro salio en la tienda hermana y conviene dejarlo escrito,
      porque parece que "esconde" errores y lo que hace es provocarlos: fuerza
      el Content-Type a texto plano, el receptor recibe el cuerpo como CADENA en
      vez de objeto, el telefono llega vacio, y el lead muere en un 400 mientras
      el formulario le dice al cliente "listo, te avisamos".
      La respuesta ademas es opaca: un 404 o un 500 llegan como exito.
      Aqui se comprueba `res.ok` y punto. Lo que lo permite es tener el origen
      permitido configurado en el webhook de n8n (Allowed Origins), no `*`.

   2. NO HAY TOPE DE FRECUENCIA EN localStorage.
      El tema trae `popup-triggers.js` con uno (`mga_popup_state_v1`) y aqui NO
      se usa. Guardar "a este ya se lo enseñe" hace que el cliente que se apunta
      a un SEGUNDO producto se encuentre un boton que no hace nada, sin ningun
      error. Esto no es un popup de marketing: es la unica conversion de la
      tienda. Se ofrece siempre.
      El unico uso de localStorage aqui es la red de los leads que NO salieron
      (`jowi_avisos_sin_enviar_v1`), que es lo contrario: no esconde nada.

   3. NO HAY NI UN TEXTO DE CARA AL CLIENTE EN ESTE FICHERO.
      Todo llega por `data-msg-*`, rellenado desde Liquid con `| t`. Si un
      mensaje se escribe aqui sale en ingles para el cliente en español y NADIE
      SE ENTERA, porque el resto del formulario si esta traducido. Lo unico que
      este fichero escribe directo es el espaciador del boton mientras envia, y
      eso tambien viene por atributo.
   ============================================================ */
(function () {
  'use strict';

  var CLAVE_PENDIENTES = 'jowi_avisos_sin_enviar_v1';
  var MAX_PENDIENTES = 50;

  /* ---------------------------------------------------------------
     Telefono a E.164 de EE. UU.
     Se normaliza AQUI, en el tema, no en destino: GoHighLevel limpia en la
     ingesta pero Twilio no, y un numero con parentesis llega a Twilio tal cual.
     n8n lo vuelve a hacer a proposito (defensa en profundidad): si mañana
     alguien toca este fichero, el destino sigue protegido.

     Ni el prefijo de zona ni el de central pueden empezar por 0 ni por 1: es lo
     que descarta 000-000-0000 y demas relleno sin tener que mantener una lista.

     DEVUELVE `{ ok, e164 }`, Y ESO NO ES UN CAPRICHO DE ESTILO.

     Antes devolvia tres cosas distintas: el numero si valia, `null` si estaba
     escrito y no valia, y `''` si el campo estaba vacio. Parece razonable -son
     tres situaciones de verdad distintas- y abrio un agujero que estuvo vivo sin
     que nadie lo viera: quien llamaba comprobaba `=== null`, que es la
     comprobacion CORRECTA de «no vale»... y el campo vacio, que devuelve `''`,
     pasaba de largo. El telefono era obligatorio en el HTML y opcional de
     verdad, y el apuntado entraba sin numero sin que fallara nada.

     Lo que hace que no se repita no es acordarse mas: es que **con un booleano
     no hay un tercer caso que olvidar**. El vacio cae en `ok:false` igual que el
     numero malo, y quien llama solo puede escribir `!r.ok`. Si alguien
     «simplifica» esto algun dia para que devuelva el numero o una cadena vacia,
     reabre el agujero entero aunque todo lo demas siga bien. Diagnostico de la
     tienda hermana, 12/09/2026; esta escrito en su volumen 1, §5B.7bis.

     Quien llama sigue distinguiendo el vacio ANTES de llamar aqui, para poder
     decir «te falta el telefono» en vez de «ese numero no cuadra». Pero eso es
     por el mensaje, no por la seguridad: si esa comprobacion desapareciera, el
     vacio seguiria sin colarse.
     --------------------------------------------------------------- */
  function e164(bruto) {
    var txt = String(bruto || '').trim();
    if (!txt) return { ok: false, e164: '' };
    var internacional = txt.charAt(0) === '+';
    var d = txt.replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length === 10) {
      var zonaOk = d.charAt(0) !== '0' && d.charAt(0) !== '1';
      var centralOk = d.charAt(3) !== '0' && d.charAt(3) !== '1';
      if (zonaOk && centralOk) return { ok: true, e164: '+1' + d };
      return { ok: false, e164: '' };
    }
    /* Numero de fuera con su prefijo internacional: se respeta. Sin el `+`
       delante no se adivina — 11 o 13 digitos sueltos son casi siempre un
       numero mal tecleado, no un extranjero. */
    if (internacional && d.length >= 11 && d.length <= 15) return { ok: true, e164: '+' + d };
    return { ok: false, e164: '' };
  }

  function correoValido(v) {
    var t = String(v || '').trim();
    return t.length > 4 && t.length < 255 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(t);
  }

  /* Red de seguridad: si el `fetch` no sale (sin red, n8n caido), el lead se
     queda en el navegador del cliente con la hora y el motivo. No es un buzon
     consultable -vive en SU navegador- pero permite reintentar sin que el
     cliente tenga que volver a escribirlo todo. */
  function guardaPendiente(payload, motivo) {
    try {
      var lista = JSON.parse(localStorage.getItem(CLAVE_PENDIENTES) || '[]');
      lista.push({ cuando: new Date().toISOString(), motivo: String(motivo), payload: payload });
      localStorage.setItem(CLAVE_PENDIENTES, JSON.stringify(lista.slice(-MAX_PENDIENTES)));
    } catch (e) { /* modo privado, cuota llena: no es motivo para romper nada */ }
  }

  function plantilla(txt, datos) {
    return String(txt || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return datos[k] == null ? '' : datos[k];
    });
  }

  /* ---------------------------------------------------------------
     EL CORREO NO SE LEE POR `name`, SE LEE POR `data-aviso-email`.

     El campo pasa a llamarse `contact[email]` porque es lo que EXIGE el
     formulario nativo de Shopify; antes se llamaba `email`. Leerlo del
     `FormData` por la clave `email` devolvia `undefined`, y con eso el
     formulario rechazaba TODOS los envios con "necesitamos un correo" aunque
     el correo estuviera escrito. Ese es el fallo que este enganche evita.

     Por eso se engancha por ATRIBUTO y no por nombre: el `name` pertenece al
     contrato de Shopify y puede volver a cambiar; `data-aviso-email` es
     nuestro. Los dos respaldos por `name` cubren cualquier formulario que
     todavia no lleve el atributo.
     --------------------------------------------------------------- */
  function campoCorreo(form) {
    return form.querySelector('[data-aviso-email]') ||
           form.querySelector('input[name="contact[email]"]') ||
           form.querySelector('input[name="email"]');
  }

  /* ---------------------------------------------------------------
     LAS ETIQUETAS DEL APUNTADO NATIVO.

     Por la via nativa el lead entra en Clientes de Shopify, y ahi lo UNICO que
     viaja ademas del correo es `contact[tags]`: el formulario `customer`
     descarta EN SILENCIO cualquier otro campo. O sea que la talla, el SKU y el
     telefono o van dentro de la etiqueta o NO VAN A NINGUN SITIO.

     Se repinta en dos momentos, y los dos hacen falta:
       · al cambiar la talla en el popup — sin esto el apuntado nativo lleva la
         talla que estaba puesta al CARGAR la pagina, no la que eligio, y nadie
         se entera hasta que le llega el aviso de la talla equivocada;
       · al enviar, para meter el telefono ya normalizado.

     Dos trampas de las etiquetas de Shopify:
       · la coma SEPARA etiquetas, asi que una coma dentro de un valor parte la
         etiqueta en dos. Se cambian por espacios.
       · Shopify las pasa a MINUSCULAS sin avisar (lo cazo la tienda hermana
         con `sku:TL-00010` → `sku:tl-00010`). Se mandan ya en minusculas para
         que lo que se envia sea lo que se guarda; al cruzarlas con el catalogo
         hay que comparar los dos lados en minusculas.
     --------------------------------------------------------------- */
  function limpiaTag(v) {
    return String(v || '').replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* ---------------------------------------------------------------
     `slug()` — LA MISMA FUNCION EN LOS TRES SITIOS.

     La etiqueta de una variante se arma en tres sitios distintos y los tres
     tienen que dar LA MISMA CADENA:
       1. `snippets/aviso-stock.liquid`, con `| handleize`, al servir la pagina
       2. aqui, al cambiar de talla en el popup y al enviar
       3. el nodo `Normalizar y validar` de `n8n/JOWI-01-aviso-stock.json`
     Si difieren, el mismo apuntado queda con dos etiquetas segun por donde
     entro, y el dia que llegue mercancia el filtro no encuentra a nadie.

     Antes esto era `.toLowerCase()` a secas y salia `talla:6-12 months` CON
     ESPACIO: media etiqueta. El SKU colaba porque no lleva espacios.

     No se usa para el TELEFONO (el `+` de E.164 se perderia) ni para el texto
     libre de `busca:` (es para leerlo, no para filtrarlo).
     --------------------------------------------------------------- */
  function slug(s) {
    /* El rango \u0300-\u036f son las tildes que `NFKD` deja sueltas. Va con
       escapes y no con los caracteres literales a proposito: escritos en
       crudo son invisibles y cualquier editor que reescriba el fichero los
       puede perder sin que se note hasta que llega un nombre con acento. */
    return String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  /* EL CAMPO DE LAS ETIQUETAS PUEDE SER DOS COSAS.
     Sin tallas es un `<input type="hidden">`. Con tallas son las PASTILLAS:
     radios que se llaman `contact[tags]`, de los que el navegador manda solo
     el marcado -asi el apuntado nativo lleva la talla elegida aunque no haya
     JS-. Escribir en el primero que aparezca pintaria la etiqueta en una
     pastilla que quiza no es la marcada, y se mandaria la talla de otra. */
  function campoTags(form) {
    return form.querySelector('input[type="radio"][data-aviso-tags-nativo]:checked') ||
           form.querySelector('[data-aviso-tags-nativo]:not([type="radio"])');
  }

  function pintaTagsNativo(form, tel) {
    var campo = campoTags(form);
    if (!campo) return;
    function val(sel) {
      var el = form.querySelector(sel);
      return el ? limpiaTag(el.value) : '';
    }
    var tags = ['esperando-stock'];
    /* `origen:` SOLO en los formularios abiertos (portada, escaparate). En la
       ficha `esperando-stock` ya dice de donde viene, y n8n tampoco lo emite
       ahi: ponerlo aqui hacia que la etiqueta de la ficha llevara un trozo de
       mas que ninguna de las otras dos fuentes escribe. */
    var origen = val('input[name="formulario"]');
    if (origen && origen !== 'ficha') tags.push('origen:' + slug(origen));
    var sku = val('[data-aviso-sku]');
    if (sku) tags.push('sku:' + slug(sku));
    /* LA TALLA SALE DE `talla_tag`, NO DEL ROTULO — y esto es lo que arregla
       el fallo gordo. El rotulo (`data-aviso-talla`) ESTA TRADUCIDO: en
       español vale "6-12 meses", asi que etiquetar a partir de el producia
       `talla:6-12-meses` en /es y `talla:6-12-months` en ingles, dos etiquetas
       para la MISMA variante. `talla_tag` lo calcula `aviso-stock.liquid` a
       partir del SKU -que Shopify no traduce- y aqui solo se transporta.
       El `slug()` se vuelve a aplicar por si acaso: es idempotente, no puede
       estropear un valor que ya viene limpio.

       Vacio significa TALLA UNICA (las dos variantes `Default Title` del
       catalogo, la diadema y la manta) y entonces NO se emite `talla:`: seria
       una talla inventada que no esta en ninguna guia. Quien fabrica ya sabe
       cual es por el `sku:`. */
    var talla = slug(val('[data-aviso-talla-tag]'));
    if (talla) tags.push('talla:' + talla);
    /* EL TELEFONO EN UNA ETIQUETA ES UN APAÑO, Y ESTA ESCRITO A PROPOSITO.
       Es obligatorio por decision del cliente (12/09/2026) y el formulario
       `customer` de Shopify no tiene donde guardarlo. Dentro de la etiqueta se
       conserva y se puede migrar a GHL el dia que exista el webhook; fuera de
       ella se pierde entero. No es el sitio definitivo: el sitio definitivo es
       el CRM, que es el escalon 1 de la jerarquia. */
    if (tel) tags.push('tel:' + tel);
    /* EL TEXTO LIBRE DE LA PORTADA, recortado. Es el dato que mas vale de ese
       formulario -dice que estampado y que talla fabricar- y por la via nativa
       no tiene ningun otro sitio donde caber. Se recorta a 180 caracteres
       porque una etiqueta de Shopify admite 255 y aqui ya va con prefijo.
       Degradado, si; perdido, no. Entero solo viaja por el CRM. */
    var busca = val('[name="buscando"]');
    if (busca) tags.push('busca:' + busca.slice(0, 180));
    campo.value = tags.join(',');
  }

  /* ---------------------------------------------------------------
     LA TALLA — solo en la ficha.
     El selector del bloque manda sobre el SKU que se envia: el comprador puede
     estar mirando la 2T y apuntarse a la 4T sin cambiar de pagina.

     Y al reves: si cambia la talla ARRIBA (las pastillas de la ficha), el
     bloque la sigue... salvo que el visitante ya haya tocado el selector de
     aqui. Ese es el `tocado`: una vez ha elegido a mano, nadie le pisa la
     eleccion. Sin esa marca, tocar las pastillas de arriba le cambiaria por
     detras la talla a la que se esta apuntando.
     --------------------------------------------------------------- */
  function montaTalla(bloque, form) {
    /* Las pastillas son radios `contact[tags]`; antes esto era un `<select>`,
       que el cliente rechazo porque desplegaba la lista NATIVA DEL SISTEMA
       encima del popup. Lo que cambia es el mecanismo, no el dato: la talla
       elegida sigue mandando su SKU y su etiqueta. */
    var pills = Array.prototype.slice.call(
      form.querySelectorAll('input[type="radio"][data-aviso-tags-nativo]'));
    var campoSku = form.querySelector('[data-aviso-sku]');
    var campoTalla = form.querySelector('[data-aviso-talla]');
    var campoTallaTag = form.querySelector('[data-aviso-talla-tag]');
    var campoId = form.querySelector('[data-aviso-variant-id]');
    var mapaEl = bloque.querySelector('[data-aviso-variantes]');
    var variantes = [];
    if (mapaEl) { try { variantes = JSON.parse(mapaEl.textContent); } catch (e) { variantes = []; } }
    var tocado = false;

    function aplica(id) {
      var v = variantes.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (campoId) campoId.value = v.id;
      if (campoSku) campoSku.value = v.sku || '';
      if (campoTalla) campoTalla.value = v.talla || '';
      /* `talla_tag` viene YA CALCULADA de Liquid y no se deduce del rotulo:
         el rotulo esta traducido y deducirla de el etiquetaba `talla:6-12-meses`
         en español para la misma variante que en ingles daba `6-12-months`. */
      if (campoTallaTag) campoTallaTag.value = v.talla_tag || '';
      /* LA ETIQUETA NATIVA VA DETRAS DEL SKU, SIEMPRE.
         Si se repinta el SKU oculto y no la etiqueta, el apuntado por la via
         nativa entra en Clientes con la talla de la carga de la pagina. El
         cliente elige la 4T, se apunta, y en Shopify queda `talla:newborn`. */
      pintaTagsNativo(form, '');
    }

    function marca(input) {
      /* El radio dentro de un `<label>` NO SIEMPRE emite `change` al pulsar el
         label: se marca a mano para no depender de ello. Es la misma cautela
         que ya tienen las pastillas de la ficha en `main-product.liquid`. */
      if (!input.checked) input.checked = true;
      pills.forEach(function (p) {
        var lbl = p.closest('.option-pill');
        if (lbl) lbl.classList.toggle('is-active', p === input);
      });
      aplica(input.getAttribute('data-aviso-variante'));
    }

    pills.forEach(function (input) {
      var lbl = input.closest('.option-pill');
      if (lbl) {
        lbl.addEventListener('click', function () {
          tocado = true;
          marca(input);
          /* Si ya se habia apuntado y ahora elige otra talla, se le devuelve el
             formulario para que pueda apuntarse tambien a esta. Apuntarse a una
             talla no deberia cerrarle la puerta a la siguiente. */
          reabre(bloque, form);
        });
      }
      /* Y el teclado: con las flechas el navegador mueve la marca del grupo sin
         que haya ningun clic. Sin esto, elegir con el teclado cambiaba la
         pastilla marcada y no el SKU que se manda. */
      input.addEventListener('change', function () {
        tocado = true;
        marca(input);
        reabre(bloque, form);
      });
    });

    if (pills.length) {
      var marcado = pills.filter(function (p) { return p.checked; })[0] || pills[0];
      marca(marcado);
    }

    /* DOS EVENTOS, Y EL QUE MANDA ES EL PRIMERO.

       `aviso:variante` lo emite la ficha DE FORMA SINCRONA en cuanto resuelve
       la talla elegida. `variant:change` lo emite despues, al volver de la
       peticion que repinta el precio. Se escuchan los dos porque el segundo ya
       existia y es el contrato publico de la ficha, pero la correccion del SKU
       NO puede depender de una peticion de red: si tarda o falla, el popup se
       quedaria con el SKU de la talla anterior y al cliente se le avisaria de
       una talla que no pidio. */
    function sigueALaFicha(id) {
      if (!id || tocado) return;
      var input = pills.filter(function (p) {
        return String(p.getAttribute('data-aviso-variante')) === String(id);
      })[0];
      /* `marca()` y no `aplica()`: si la pastilla de arriba cambia y aqui no se
         mueve la marca, el popup enseñaria una talla y mandaria otra. */
      if (input) { marca(input); return; }
      aplica(id);
    }

    document.addEventListener('aviso:variante', function (ev) {
      sigueALaFicha(ev && ev.detail && ev.detail.id);
    });
    document.addEventListener('variant:change', function (ev) {
      sigueALaFicha(ev && ev.detail && ev.detail.variant && ev.detail.variant.id);
    });
  }

  function reabre(bloque, form) {
    var ok = bloque.querySelector('[data-aviso-ok]');
    if (!ok || ok.hidden) return;
    ok.hidden = true;
    form.hidden = false;
  }

  /* ---------------------------------------------------------------
     EL POPUP DE LA FICHA — `<dialog>` del navegador, sin motor propio.

     El tema trae `popup-triggers.js` y NO se usa aqui. Ese motor guarda en
     localStorage "a este popup ya se lo enseñe" y con eso el cliente que se
     apunta a un SEGUNDO producto se encuentra un boton que no hace nada y
     ningun error. Con `<dialog>` no hay estado que guardar, asi que ese fallo
     no puede existir; y el foco, la tecla Escape y el fondo los pone el
     navegador, que es codigo que no hay que escribir ni mantener.

     Degradacion: si el navegador no tiene `showModal` (o el JS no carga), el
     popup no se abre y la ficha sigue siendo una ficha. Se cubre el primer
     caso con el atributo `open`, que enseña el dialogo en linea.
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     LA VUELTA DEL ENVIO NATIVO — sin esto el apuntado se hace y no se ve.

     La via nativa RECARGA la pagina: el mensaje de exito que pinta el `fetch`
     no llega a existir, y el cliente vuelve a la ficha exactamente igual que
     estaba. Se ha apuntado y no lo sabe, asi que se apunta otra vez, o se va
     pensando que no funciono.

     Shopify devuelve `?customer_posted=true` al volver. Eso dice QUE se
     guardo, pero no CON QUE: el correo y la talla no viajan de vuelta. Por eso
     se dejan en `sessionStorage` justo antes de mandar y se recogen aqui. Es
     sessionStorage y no localStorage a proposito: vale para este viaje y para
     esta pestaña, y no deja rastro que confunda mañana.

     Se limpian las dos cosas —la marca de la URL y el deposito— para que
     recargar la pagina no vuelva a enseñar un exito que ya paso.
     --------------------------------------------------------------- */
  var CLAVE_VUELTA = 'jowi_aviso_enviado_v1';

  function guardaParaLaVuelta(datos) {
    try { sessionStorage.setItem(CLAVE_VUELTA, JSON.stringify(datos)); } catch (e) {}
  }

  function recogeLaVuelta() {
    var url;
    try { url = new URL(window.location.href); } catch (e) { return null; }
    if (url.searchParams.get('customer_posted') !== 'true') return null;
    var datos = null;
    try {
      datos = JSON.parse(sessionStorage.getItem(CLAVE_VUELTA) || 'null');
      sessionStorage.removeItem(CLAVE_VUELTA);
    } catch (e) { datos = null; }
    url.searchParams.delete('customer_posted');
    try { window.history.replaceState({}, '', url.toString()); } catch (e) {}
    /* Sin deposito igual hubo alta —otra pestaña, sessionStorage bloqueado—,
       asi que se confirma igual, solo que sin el correo ni la talla dentro. */
    return datos || {};
  }

  function montaModal(bloque) {
    var abrir = bloque.querySelector('[data-aviso-abrir]');
    var modal = bloque.querySelector('[data-aviso-modal]');
    if (!abrir || !modal) return;

    /* EL BOTON NACE ESCONDIDO Y LO ENSEÑA ESTE FICHERO.

       Sin JavaScript el popup no puede abrirse, y un boton que no hace nada es
       peor que ninguno: el visitante pulsa, no pasa nada, y se va pensando que
       la tienda esta rota. Enseñandolo desde aqui, si el JS no carga lo que
       queda es el texto de "ya llega" —que es verdad y no promete nada— en vez
       de una puerta pintada.

       La tienda hermana degrada a un `<a href="tel:">` con el telefono de la
       tienda. Aqui no vale: no pedimos que nadie llame y no hay un numero
       atendido que ofrecer. */
    abrir.hidden = false;

    abrir.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      var primero = modal.querySelector('input[type="email"]');
      if (primero) primero.focus();
    });

    function cierra() {
      if (typeof modal.close === 'function' && modal.open) modal.close();
      else modal.removeAttribute('open');
      abrir.focus();
    }

    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-aviso-cerrar]')) { cierra(); return; }
      /* Clic en el fondo: el `<dialog>` ocupa toda la pantalla y la caja vive
         dentro, asi que un clic cuyo destino es el propio dialogo es un clic
         fuera de la caja. */
      if (ev.target === modal) cierra();
    });
  }

  /* --------------------------------------------------------------- */
  function monta(form) {
    var bloque = form.closest('[data-aviso-bloque]') || form.parentElement;
    var tipo = form.dataset.avisoForm;                 // 'ficha' | 'portada'
    var endpoint = form.dataset.endpoint;
    var error = form.querySelector('[data-aviso-error]');
    var ok = bloque.querySelector('[data-aviso-ok]');
    var boton = form.querySelector('[type="submit"]');

    /* -----------------------------------------------------------------
       `novalidate` SE PONE DESDE AQUI, NO EN EL HTML.

       Estaba escrito en el `<form>` de Liquid, y eso abria un agujero que
       señalo la tienda hermana (volumen 1, §5B.8): **si este guion no carga,
       el `novalidate` sigue puesto y el navegador tampoco comprueba los
       `required`**. El formulario cae al envio nativo de Shopify y se manda
       vacio. Justo en el caso en que no hay nadie validando es cuando el
       atributo que apaga al navegador seguia activo.

       Poniendolo aqui las dos ramas quedan cubiertas y no se pisan:
         · con JS  -> `noValidate = true`, valida este guion y enseña los
                      mensajes de la tienda, en el idioma del visitante
         · sin JS  -> el atributo no llega a existir, el navegador exige sus
                      `required` y el envio nativo no sale vacio

       Los globos del navegador y los mensajes de aqui no compiten nunca,
       porque no hay ningun momento en que esten los dos.
       ----------------------------------------------------------------- */
    form.noValidate = true;

    /* -----------------------------------------------------------------
       CON WEBHOOK, EL FORMULARIO DEJA DE SER «CUSTOMER» DE SHOPIFY.

       Comprobado en la tienda viva el 26/10/2026: el antibot de Shopify se
       engancha a todo `<form>` con `action=/contact` y `form_type=customer`
       ANTES que este guion. Al pulsar «Apunta mi talla» salia el `fetch` a
       n8n y a la vez Shopify mandaba al visitante a `/challenge` (hCaptcha):
       la navegacion cortaba el `fetch` («Failed to fetch») y el apuntado no
       llegaba a la app. El cliente se quedaba en un captcha.

       Con endpoint no hay via nativa que proteger -el `fetch` no la usa-,
       asi que se le quita a Shopify lo que reconoce. Sin JS esto no corre y
       el formulario nativo sigue intacto, que es el respaldo de siempre.
       ----------------------------------------------------------------- */
    if (endpoint) {
      form.removeAttribute('action');
      var tipoNativo = form.querySelector('[name="form_type"]');
      if (tipoNativo) tipoNativo.disabled = true;
    }

    if (tipo === 'ficha') {
      montaTalla(bloque, form);
      montaModal(bloque);
    }

    /* LA CONFIRMACION DEL ENVIO NATIVO, al volver de la recarga.
       Solo la recoge el PRIMER formulario que se monta: la marca de la URL es
       una y no se puede repartir entre dos. */
    if (!monta.vueltaHecha) {
      var vuelta = recogeLaVuelta();
      if (vuelta && ok) {
        monta.vueltaHecha = true;
        ok.textContent = plantilla(form.dataset.msgSuccess, {
          email: vuelta.email || '',
          size: vuelta.talla || '',
          talla: vuelta.talla || ''
        });
        ok.hidden = false;
        form.hidden = true;
        /* En la ficha el mensaje vive DENTRO del `<dialog>`: si no se abre, el
           cliente vuelve a una pagina sin noticias de lo que acaba de hacer.
           Abrirlo aqui no es un popup no pedido: es la respuesta a su envio. */
        var modalVuelta = bloque.querySelector('[data-aviso-modal]');
        if (modalVuelta && typeof modalVuelta.showModal === 'function' && !modalVuelta.open) {
          try { modalVuelta.showModal(); } catch (e) {}
        }
      }
    }

    /* -----------------------------------------------------------------
       EL UNICO SITIO QUE DICE «NO» ES EL MISMO QUE DICE «POR QUE».

       Regla de la tienda hermana (volumen 1, §5B.1), y la razon de que exista
       esta funcion: mientras «no pasa» y «avisar de por que» eran dos lineas
       sueltas, cabia un camino que rechazara el envio sin pintar nada. Un
       formulario que no se manda y no explica nada es indistinguible de uno
       roto, y el visitante se va.

       Ahora rechazar ES llamar aqui. `fallar()` devuelve `false` siempre, asi
       que se usa como `return fallar(campo, mensaje)` y no hay forma de salir
       en negativo sin haber avisado.

       Cuatro señales a la vez, que es lo que hace la hermana: el texto en el
       `<p role="alert">` -que los lectores de pantalla cantan solos-, el borde
       rojo, `aria-invalid` y el foco en el campo culpable.
       ----------------------------------------------------------------- */
    function muestraError(msg) {
      if (!error) return;
      error.textContent = msg;
      error.hidden = false;
    }
    function limpiaError() {
      if (error) { error.hidden = true; error.textContent = ''; }
      /* Los rojos de la vuelta anterior se quitan SIEMPRE al empezar. Sin
         esto, corregir el correo dejaba el teléfono marcado en rojo. */
      var marcados = form.querySelectorAll('.aviso__input--error, [aria-invalid="true"]');
      Array.prototype.forEach.call(marcados, function (c) {
        c.classList.remove('aviso__input--error');
        c.removeAttribute('aria-invalid');
      });
    }
    function fallar(campo, msg) {
      muestraError(msg);
      if (campo) {
        campo.classList.add('aviso__input--error');
        campo.setAttribute('aria-invalid', 'true');
        campo.focus();
      }
      return false;
    }

    form.addEventListener('submit', function (ev) {
      limpiaError();

      var datos = {};
      new FormData(form).forEach(function (v, k) { datos[k] = v; });

      /* ---------------------------------------------------------------
         VALIDAR SIEMPRE; INTERCEPTAR SOLO SI HAY A DONDE MANDARLO.

         El formulario lleva `novalidate`, asi que si aqui no se comprueba
         nada no lo comprueba nadie. Por eso la validacion va ANTES de decidir
         la via, y un campo mal escrito para el envio por las dos.
         --------------------------------------------------------------- */
      /* -------------------------------------------------------------
         EL NOMBRE, Y POR QUE SE PIDE.

         Decision del cliente del 12/09/2026, sobre la medicion de la tienda
         hermana: **el upsert de GoHighLevel pisa el nombre que ya tuviera el
         contacto**. Probado alli con un contacto real: mandando `firstName` en
         el upsert, «PRUEBA E2E» sustituyo al nombre anterior; sin mandarlo, el
         anterior sobrevivio. O sea que un nombre de relleno tipo «Visitante
         interesado» le habria borrado el nombre bueno a cualquiera que ya
         estuviera en el CRM y volviera por aqui. Sin aviso y sin rastro.

         Habia tres salidas y se eligio la unica que no tiene pega: **pedir el
         nombre**. No hay relleno que pise nada, en la lista del CRM se lee una
         persona y no un correo suelto, y el dia que se avise de una tanda se
         puede escribir «Marta, ha salido tu talla» en vez de «Hola».

         Se valida solo que no este vacio y que quepa. Aqui NO se comprueba si
         «parece un nombre»: los apellidos compuestos, los nombres de una letra,
         los acentos y los alfabetos no latinos son nombres de verdad, y un
         filtro listo de mas rechaza a personas reales. Lo unico que se corta es
         el vacio y lo absurdamente largo.
         ------------------------------------------------------------- */
      /* Se busca por `data-aviso-nombre` y NO por el atributo `name`, por lo
         mismo que el correo: el campo se llama `contact[first_name]` porque es
         lo que exige el formulario `customer` de Shopify para el envio sin
         JavaScript, y ese nombre es de Shopify, no nuestro. El dia que Shopify
         cambie su contrato, el `data-*` sigue valiendo. */
      var campoNombre = form.querySelector('[data-aviso-nombre]');
      var nombreVal = String((campoNombre && campoNombre.value) || datos['contact[first_name]'] || '').trim();
      if (campoNombre && (!nombreVal || nombreVal.length > 80)) {
        ev.preventDefault();
        fallar(campoNombre, form.dataset.msgName);
        return;
      }

      var campoEmail = campoCorreo(form);
      var email = String((campoEmail && campoEmail.value) || datos.email || '').trim();
      if (!correoValido(email)) {
        ev.preventDefault();
        fallar(campoEmail, form.dataset.msgEmail);
        return;
      }

      var campoTel = form.querySelector('input[name="phone"]');
      var telCrudo = String((campoTel && campoTel.value) || datos.phone || '').trim();

      /* -------------------------------------------------------------
         VACIO SE RECHAZA APARTE, Y ANTES DE NORMALIZAR.

         Esto estaba MAL y pasaba desapercibido. El campo lleva `required`,
         pero el formulario lleva `novalidate`, asi que el navegador no
         comprueba ese `required`: lo comprueba este guion o no lo comprueba
         nadie. Y aqui no se comprobaba: `e164('')` devolvia cadena vacia -no
         `null`- y la unica condicion era `=== null`. Resultado: **el telefono
         era obligatorio en el HTML y opcional de verdad.** Se enviaba sin
         numero y nadie se enteraba. La raiz estaba en la FIRMA de `e164()`, que
         ya esta cambiada: ver el comentario largo de esa funcion.

         El mensaje tampoco ayudaba: decia «o dejalo en blanco», que era
         cierto cuando el telefono era opcional y dejo de serlo cuando el
         cliente lo hizo obligatorio. Un mensaje que invita a hacer justo lo
         que el formulario no acepta.

         Dos mensajes distintos a proposito: «te falta el telefono» y «ese
         numero no me cuadra» son dos problemas y se arreglan de dos maneras.
         ------------------------------------------------------------- */
      /* `campoTel &&`: EL TELEFONO SOLO ES OBLIGATORIO DONDE SE PIDE.

         Este mismo motor lo usa ahora el captador de correo del pie, que pide
         SOLO el correo. Sin esta condicion, ese formulario quedaba bloqueado
         para siempre pidiendo un telefono que no existe en pantalla: el peor
         tipo de bloqueo, porque el visitante no puede arreglarlo ni viendolo.
         Donde el campo existe no cambia nada: sigue siendo obligatorio. */
      if (campoTel && !telCrudo) {
        ev.preventDefault();
        fallar(campoTel, form.dataset.msgPhoneEmpty || form.dataset.msgPhone);
        return;
      }

      var tel = '';
      if (telCrudo) {
        var resTel = e164(telCrudo);
        if (!resTel.ok) {
          ev.preventDefault();
          fallar(campoTel, form.dataset.msgPhone);
          return;
        }
        tel = resTel.e164;
      }

      /* -------------------------------------------------------------
         EL CONSENTIMIENTO DE CORREO SI ES OBLIGATORIO, Y ES OTRO.

         No confundir con `data-aviso-consent`, que es el de SMS y es
         VOLUNTARIO: quien no lo marca deja su telefono para que le llamen y
         punto. Este es el de marketing por correo, y sin el no se puede
         mandar publicidad a nadie. Si el formulario lo pinta, se exige.

         Y se comprueba aqui, en el JS, porque la casilla estaba ANTES FUERA
         del `<form>`: no se enviaba, el navegador no la validaba, y la tienda
         no guardaba ninguna prueba de que nadie hubiera aceptado nada.
         ------------------------------------------------------------- */
      var consentMail = form.querySelector('[data-aviso-consent-email]');
      if (consentMail && !consentMail.checked) {
        ev.preventDefault();
        fallar(consentMail, form.dataset.msgConsent);
        return;
      }

      /* -------------------------------------------------------------
         EL CAMPO SE REESCRIBE CON EL NUMERO YA NORMALIZADO.

         Copiado de la hermana (volumen 1, §5B.5). Dos cosas gratis: el
         visitante VE con que numero se le va a escribir y puede corregirlo
         antes de darle otra vez, y lo que viaja a GHL es exactamente lo que
         el vio. `(305) 555-0123` se convierte en `+13055550123` delante de
         sus ojos, que es como va a quedar guardado.
         ------------------------------------------------------------- */
      if (campoTel && tel) campoTel.value = tel;

      /* El rotulo original del boton, capturado ANTES de tocarlo. Lo necesitan
         las dos vias para poder devolverlo si el envio no sale. */
      var etiquetaNativa = boton ? boton.textContent : '';

      /* ---------------------------------------------------------------
         SIN ENDPOINT NO SE INTERCEPTA: MANDA EL NAVEGADOR.

         Este es el escalon 2 de la jerarquia acordada con la tienda hermana:

           1. formulario que guarda en el CRM          <- cuando haya webhook
           2. formulario que guarda en Shopify nativo  <- ESTO
           3. enlace de telefono, si hay numero atendido
           4. no pintar nada

         Antes se hacia `preventDefault()` siempre y despues se intentaba un
         `fetch` a una cadena vacia: el navegador lo mandaba a la propia URL de
         la pagina, volvia un HTML con 200, el formulario decia "te avisamos"
         y EL LEAD NO EXISTIA EN NINGUN SITIO. Es el fallo mas caro posible
         aqui, porque no da error: se ve exactamente igual que funcionar.

         Al no llamar a `preventDefault()` el navegador manda el formulario a
         `action` —`/contact#contact_form` con `form_type=customer`— y el
         apuntado entra en Clientes de Shopify con sus etiquetas. La pagina
         recarga: eso es lo que se pierde frente a la via del CRM, y es
         aceptable mientras no haya webhook.

         El dia que se pegue el webhook en el editor, `data-endpoint` deja de
         estar vacio y esta misma funcion vuelve a interceptar sin tocar nada.
         --------------------------------------------------------------- */
      if (!endpoint) {
        pintaTagsNativo(form, tel);

        /* ------------------------------------------------------------
           CON JAVASCRIPT, EL RESPALDO VA POR `fetch` Y NO SE SALE DE LA FICHA.

           Mandarlo con el navegador funciona, pero se lleva al visitante a
           `/contact`: pierde el popup, el mensaje de exito y la ficha que
           estaba mirando. Copiado de la tienda hermana (`popup-ghl.js`), con
           dos diferencias a favor nuestro:

             · la URL sale de `form.action`, que Liquid ya construyo con el
               idioma puesto (`/contact` en ingles, `/es/contact` en español).
               La hermana la lleva escrita a mano; aqui eso mandaria al
               cliente en español a una ruta que no existe;
             · si el `fetch` no sale, SE MANDA IGUAL por la via del navegador.
               Asi el peor caso es lo de antes -recargar la pagina- y nunca
               perder el lead.

           Y no se quita el `action` del `<form>`: el respaldo de la hermana
           NECESITA JavaScript, el nuestro no. La jerarquia entera queda:
             con endpoint + JS -> n8n -> GoHighLevel
             sin endpoint + JS -> fetch a /contact, exito sin salir de aqui
             sin JS            -> el <form> nativo se manda solo

           TAMBIEN VAN EL TELEFONO Y EL NOMBRE. El formulario `customer` de
           Shopify si tiene `contact[phone]`, asi que el telefono -obligatorio
           por decision del cliente- cabe en su campo y no solo dentro de una
           etiqueta. La etiqueta `tel:` se queda ademas: es la que se puede
           migrar a GHL el dia del webhook.

           OJO, Y ESTO NO ESTA COMPROBADO CONTRA LA TIENDA: el antibot de
           Shopify (hCaptcha) se engancha al envio NATIVO, no a un `fetch`. Si
           la tienda exige el reto para `form_type=customer`, este POST puede
           volver 200 con la pagina del reto y el apuntado no existir. Por eso
           el respaldo del respaldo -`form.submit()`- se queda: ahi si corre el
           antibot. Comprobarlo de verdad exige crear un cliente real, y el
           token de la Admin API no tiene `read_customers` ni `write_customers`
           para poder verlo ni borrarlo despues.
           ------------------------------------------------------------ */
        var campoTagsNativo = campoTags(form);
        var tagsNativos = campoTagsNativo ? campoTagsNativo.value : '';
        var nombre = campoNombre;

        if (window.fetch && form.action) {
          ev.preventDefault();
          var fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email);
          fd.append('contact[tags]', tagsNativos);
          if (tel) fd.append('contact[phone]', tel);
          if (nombre && nombre.value) fd.append('contact[first_name]', nombre.value.trim());

          if (boton) { boton.disabled = true; boton.textContent = form.dataset.msgSending || '…'; }

          fetch(form.action, { method: 'POST', body: fd })
            .then(function (res) {
              /* `throw` y no `{ok:false}`: quien llama solo mira si la promesa
                 se resuelve, asi que devolver un objeto de fallo es decirle
                 "todo bien". Es la nota de la tienda hermana y vale igual. */
              if (!res.ok) throw new Error('Shopify ' + form.action + ' respondio ' + res.status);
              if (ok) {
                ok.textContent = plantilla(form.dataset.msgSuccess, {
                  email: email, size: datos.talla || '', talla: datos.talla || ''
                });
                ok.hidden = false;
                form.hidden = true;
              }
              if (boton) { boton.disabled = false; boton.textContent = etiquetaNativa; }
              if (window.gtag) {
                window.gtag('event', 'aviso_stock_alta', { formulario: tipo, sku: datos.sku || '', via: 'shopify' });
              }
            })
            .catch(function (err) {
              /* NO se enseña error y NO se pierde el lead: se reintenta por la
                 via del navegador, que es la que ya funcionaba. Recargar la
                 pagina es peor experiencia, no un fallo. */
              console.warn('[aviso] respaldo por fetch fallido, va por el navegador', err);
              guardaParaLaVuelta({ email: email, talla: String(datos.talla || '') });
              form.submit();
            });
          return;
        }

        /* Lo que Shopify no devuelve al recargar: el correo y la talla. Se
           dejan aqui para poder confirmar de verdad al otro lado. */
        guardaParaLaVuelta({ email: email, talla: String(datos.talla || '') });
        /* El boton se apaga en el SIGUIENTE ciclo, no aqui: desactivar el
           boton de envio dentro del propio manejador de `submit` cancela el
           envio en algunos navegadores, y entonces no saldria ni por la via
           nativa ni por ninguna. Con `setTimeout` el envio ya ha salido. */
        if (boton) {
          setTimeout(function () {
            boton.disabled = true;
            boton.textContent = form.dataset.msgSending || '…';
          }, 0);

          /* ------------------------------------------------------------
             EL PERRO GUARDIAN DEL BOTON.

             Entre este `return` y la recarga de la pagina NO manda el tema:
             manda el antibot de Shopify. Su script intercepta el envio, carga
             hCaptcha y vuelve a mandar el formulario cuando el reto se
             resuelve. Si el reto NO se resuelve —se cae el proveedor, el
             visitante tiene el javascript de terceros bloqueado, la red se
             va— Shopify no avisa de nada: simplemente no pasa nada nunca.

             Sin esto, el cliente se queda con un boton apagado que pone «…»
             para siempre. Es otra vez el boton muerto, solo que esta vez lo
             habriamos puesto nosotros y encima despues de que el cliente
             escribiera sus datos.

             Comprobado el 12/09/2026: en un navegador automatizado hCaptcha
             se queda colgado y el envio no sale. El formulario de boletin que
             trae el tema —`{% form 'customer' %}` de toda la vida— se queda
             colgado EXACTAMENTE IGUAL, asi que esto no es un defecto de este
             bloque: es como se comporta el antibot. Pero el que se queda
             mirando el boton es nuestro cliente, asi que se cubre aqui.

             12 segundos: de sobra para un reto invisible, poco para que
             alguien se vaya pensando que la tienda no funciona. Si la pagina
             llega a recargar, este temporizador se muere con ella y no llega
             a verse nunca.
             ------------------------------------------------------------ */
          setTimeout(function () {
            if (!boton.disabled) return;
            boton.disabled = false;
            boton.textContent = etiquetaNativa;
            muestraError(form.dataset.msgSend);
          }, 12000);
        }
        return; // sin preventDefault: sale por la via nativa
      }

      ev.preventDefault();

      /* El consentimiento NO se deduce de que haya telefono. Si la casilla no
         esta marcada el contacto entra con consent_sms=false y n8n no le pone
         la etiqueta de SMS: el telefono queda para llamar, no para escribir. */
      var consent = form.querySelector('[data-aviso-consent]');
      var payload = {
        formulario: tipo,
        /* EL NOMBRE VA COMO `first_name` Y COMO `firstName`.
           Lo plano con guion bajo es lo que lee n8n, igual que el resto de este
           objeto; el `firstName` en camello es el nombre EXACTO del campo en la
           API de contactos de GoHighLevel, para que el upsert no tenga que
           renombrarlo por el camino. Cuesta dos bytes y evita una traduccion
           de nombres en medio del flujo, que es donde se pierden los datos. */
        first_name: nombreVal,
        firstName: nombreVal,
        email: email,
        phone: tel,
        consent_sms: consent && consent.checked ? 'true' : 'false',
        /* Solo viaja cuando el formulario pinta la casilla. Donde no la hay
           -la ficha de producto- no se manda un consentimiento que nadie ha
           dado: un `false` y un «no se pregunto» no son lo mismo, y n8n
           distingue por la ausencia del campo. */
        consent_email: consentMail ? (consentMail.checked ? 'true' : 'false') : '',
        talla: datos.talla || '',
        /* La etiqueta va APARTE del rotulo y calculada en Liquid: `talla` es
           lo que se enseña -traducido- y `talla_tag` lo que se filtra -igual
           en los dos idiomas-. n8n usa esta y solo cae en `slug(talla)` si no
           llega, que es el caso del JS viejo que siga cacheado. */
        talla_tag: datos.talla_tag || '',
        sku: datos.sku || '',
        variant_id: datos.variant_id || '',
        product_title: datos.product_title || '',
        product_handle: datos.product_handle || '',
        product_url: datos.product_url || '',
        buscando: String(datos.buscando || '').trim(),
        page_url: window.location.href,
        locale: document.documentElement.lang || '',
        country: (window.Shopify && window.Shopify.country) || '',
        /* Cookies de Meta (04/10/2026): la CAPI las manda con el Lead para que Meta reconozca
           a la persona (regla de Dadne: a Meta se le manda todo). */
        fbp: (document.cookie.match(/(?:^|; )_fbp=([^;]*)/) || [])[1] || '',
        fbc: (document.cookie.match(/(?:^|; )_fbc=([^;]*)/) || [])[1] || (new URLSearchParams(location.search).get('fbclid') ? 'fb.1.' + Date.now() + '.' + new URLSearchParams(location.search).get('fbclid') : ''),
        submitted_at: new Date().toISOString()
      };

      /* ---------------------------------------------------------------
         EL CONTEXTO VA DOS VECES, Y NO ES UN DESCUIDO.

         Plano en la raiz, que es como el disparador *Inbound webhook* de
         GoHighLevel deja mapear los campos sin pelearse con rutas anidadas; y
         dentro de `customFields`, que es la forma que espera su API de
         contactos. Copiado de la tienda hermana.

         HOY DA IGUAL: pasamos por n8n y n8n lee lo plano. Se pone porque el
         dia que alguien apunte `settings.aviso_endpoint` DIRECTAMENTE a un
         webhook entrante de GHL -sin n8n en medio, que es lo primero que se
         intenta cuando hay prisa- no habria `customFields` y los datos del
         producto se perderian sin dar ningun error. Duplicarlo no cuesta nada
         y le quita a quien venga detras una trampa que no se ve.
         --------------------------------------------------------------- */
      payload.customFields = {
        talla: payload.talla,
        talla_tag: payload.talla_tag,
        sku: payload.sku,
        product_title: payload.product_title,
        product_handle: payload.product_handle,
        product_url: payload.product_url,
        page_url: payload.page_url,
        buscando: payload.buscando,
        consent_sms: payload.consent_sms,
        locale: payload.locale,
        submitted_at: payload.submitted_at
      };

      var etiquetaBoton = etiquetaNativa;
      if (boton) { boton.disabled = true; boton.textContent = form.dataset.msgSending || '…'; }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          /* Esto es lo que `no-cors` impedia hacer. Sin esta linea un 400 del
             receptor se le enseña al cliente como "te avisamos". */
          if (!res.ok) throw new Error('El endpoint respondio ' + res.status);
          return res;
        })
        .then(function () {
          if (ok) {
            ok.textContent = plantilla(form.dataset.msgSuccess, {
              email: payload.email,
              size: payload.talla,
              talla: payload.talla
            });
            ok.hidden = false;
            form.hidden = true;
          }
          if (window.gtag) {
            window.gtag('event', 'aviso_stock_alta', { formulario: tipo, sku: payload.sku });
          }
          document.dispatchEvent(new CustomEvent('aviso:alta', { detail: payload }));
        })
        .catch(function (err) {
          guardaPendiente(payload, err && err.message);
          muestraError(form.dataset.msgSend);
          if (boton) { boton.disabled = false; boton.textContent = etiquetaBoton; }
          console.error('[aviso]', err);
        });
    });

    /* Escribir despues de un error borra el error: dejarlo en pantalla mientras
       el cliente corrige el campo le hace pensar que sigue mal. */
    form.addEventListener('input', limpiaError);
  }

  function init() {
    document.querySelectorAll('[data-aviso-form]').forEach(monta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Para quien monte la tienda: ver los leads que no salieron del navegador. */
  window.JowiAvisos = {
    pendientes: function () {
      try { return JSON.parse(localStorage.getItem(CLAVE_PENDIENTES) || '[]'); }
      catch (e) { return []; }
    },
    limpiaPendientes: function () {
      try { localStorage.removeItem(CLAVE_PENDIENTES); } catch (e) {}
    }
  };
})();
